export const IssuePriorityValidation = (formData) => {
    const errors = {};
  
    // Validate each field
    if (!formData.PriorityName.trim()) {
      errors.PriorityName = 'Priority Name is required';
    } 
    return errors;
  };
  
 